<template>
  <div class="model">
    <!-- 数据筛选 -->
    <el-card shadow="hover" class="card">
      <div class="title">运费设置</div>
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="模板名称:" prop="templeName">
          <el-input v-model="form.templeName" placeholder="请输入模板名称"></el-input>
        </el-form-item>
        <el-form-item label="计费方式:" prop="chargeType">
          <el-radio v-model="form.chargeType" :label="1" class="name-input name-input-radio">按件数</el-radio>
        </el-form-item>
      </el-form>

      <!-- 表单头部 -->
      <div class="freight flex">
        <div class="freight-region">
          <span>配送区:</span> 可配送区域
        </div>
        <div></div>
        <div>首件 (个)</div>
        <div>运费（元）</div>
        <div>续件（个）</div>
        <div>续费（元）</div>
      </div>

      <!-- 配送区域列表 -->
      <div class="list flex" v-for="(item, index) in regions" :key="index">
        <div class="region">
          <el-popover placement="left" width="200" trigger="hover">
            <div class="region-popover" style="padding: 0 0 20px 0">
              <span
                v-for="(row, indexRow) in item.citysName"
                :key="indexRow"
              >{{row.name}}{{item.citys.length-1==indexRow?'':'、'}}</span>
            </div>
            <div class="region-slot" slot="reference">
              <span
                v-for="(row, indexRow) in item.citysName"
                :key="indexRow"
              >{{row.name}}{{item.citys.length-1==indexRow?'':'、'}}</span>
            </div>
          </el-popover>
        </div>

        <div class="region-item flex">
          <el-button type="text" @click="modify(index)">修改</el-button>
          <el-button type="text" style="color:red;" @click="handleDelete(index)">删除</el-button>
        </div>

        <div class="region-item">
          <el-input
            placeholder="数字"
            v-model="item.firstValue"
            @input="inputNumber($event,index,'firstValue')"
            type="text"
            class="region-item-input"
          ></el-input>
        </div>
        <div class="region-item">
          <el-input placeholder="数字" v-model="item.firstFee" @input="limitInput($event,index,'firstFee')" type="text" class="region-item-input"></el-input>
        </div>
        <div class="region-item">
          <el-input
            placeholder="数字"
            v-model="item.continueValue"
            @input="inputNumber($event,index,'continueValue')"
            type="text"
            class="region-item-input"
          ></el-input>
        </div>
        <div class="region-item">
          <el-input
            placeholder="数字"
            v-model="item.continueFee"
            @input="limitInput($event,index,'continueFee')"
            type="text"
            class="region-item-input"
          ></el-input>
        </div>
      </div>

      <!-- 按钮 -->
      <div class="flex">
        <div style="flex:1">
          <el-button style="margin-top:20px;" @click="addModel">指定可配送区域和运费</el-button>
        </div>
        <div>
          <el-button style="margin-top:20px;" @click="resetForm('ruleForm')">取消</el-button>
          <el-button
            type="primary"
            style="margin-top:20px;"
            @click="comfirmAddFreight('ruleForm')"
          >保存</el-button>
        </div>
      </div>
    </el-card>

    <!-- 区域选择器对话框 -->
    <el-dialog :visible.sync="dialogVisible" title="配送区域" width="80%">
      <div v-for="(item,index) in cities" :key="index" style="margin-bottom:15px;">
        <div class="flex">
          <el-checkbox
            v-model="selectedAllCities[index]"
            @change="selectAll($event,index)"
            style="margin-right:25px;"
          >{{item.regionName}}</el-checkbox>
          <el-checkbox-group
            v-model="checkedCities[index]"
            @change="handleCheckedCitiesChange($event,index)"
          >
            <el-checkbox v-for="city in item.data" :label="city.id" :key="city.id">{{city.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmRegion">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// import { FreightAdd } from "@/types/api/freight";
import { freightAdd } from "@/api/freight";
import { allProvinces } from "@/api/system";
import print from "@/utils/print";
import copy from "@/utils/deepCopy";
import cities from "../data/cities";
import inputPrice from '@/utils/inputPrice'

import Freight from "./mixin/freight";

export default {
  mixins: [Freight],
  data() {
    return {
      // 提交请求的数组
      regions: [],
      // 初始化表单
      form: {
        chargeType: 1,
        templeName: "",
      },
      provinces: [], // 省份信息
    };
  },

  mounted() {
    this.getAllProvince();
  },
  methods: {
    // 获取所有省份
    getAllProvince() {
      allProvinces().then((res) => {
        this.$emit("provinces", res.data);
        localStorage.setItem("ybc_provinces", JSON.stringify(res.data));
        this.provinces = copy(res.data);
        this.setCities(res.data);
      });
    },
    // 添加模板
    comfirmAddFreight(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let regions = this.regions;
          let arr = [];
          let reg = /\S/;
          for (let index = 0; index < regions.length; index++) {
            if (
              reg.test(regions[index].continueFee) &&
              reg.test(regions[index].continueValue) &&
              reg.test(regions[index].firstFee) &&
              reg.test(regions[index].firstValue) &&
              reg.test(regions[index].citys.toString())
            ) {
              arr.push({
                chargeType: this.form.chargeType,
                continueFee: regions[index].continueFee,
                continueValue: regions[index].continueValue,
                firstFee: regions[index].firstFee,
                firstValue: regions[index].firstValue,
                region: regions[index].citys.toString(),
                templeName: this.form.templeName,
              });
            } else {
              return this.$message.error("参数有误");
            }
          }
          // 提交请求
          freightAdd(arr).then((res) => {
            this.$message.success("保存成功");
            this.resetForm(formName);
            this.$emit("update");
            Object.keys(this.selectedAllCities).map((e) => {
              this.selectedAllCities[e] = false;
            });
          });
        } else {
          return false;
        }
      });
    },
    // 取消(重置)
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.regions = [];
    },
    // 限制只能输入数字，而且只能保留两位小数
    limitInput(val, index, key) {
      this.regions[index][key] = inputPrice(val);
    },
    // 限制只能输入数字
    inputNumber(val, index,key) {
      this.regions[index][key] =  inputPrice(val, "number");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="../style.scss">
</style>
